console.log('Custom JavaScript file loaded.');

document.addEventListener("DOMContentLoaded", function() {
    // Check if the current URL ends with '/pages/test'
    if (window.location.href.endsWith('/pages/test')) {
        // Find the hero__subtitle element
        var heroSubtitle = document.querySelector('.hero__subtitle');
        
        // Get the text content of the element
        var subtitleText = heroSubtitle.textContent;

        // Create new HTML structure with appropriate styling
        var newSubtitleHTML = `
            <div class="subtitle-line">We are always looking for experienced staff to join our talented team.</div><br>
            <div class="subtitle-line">Please send your CV or resume to the email below and we’ll get back to you if there is a suitable position open for you.</div><br>
            <div class="subtitle-line">Email: <a href="mailto:info@edensalonspakw.com">info@edensalonspakw.com</a></div>
        `;

        // Set the modified HTML structure back to the element
        heroSubtitle.innerHTML = newSubtitleHTML;
    }
});
